<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-flex lg6 v-if="departmentList.length == 0">
          <label class="blackLabel">* Status Description:</label>
          <v-text-field label="Status Description" :rules="nameRules" solo v-model="statusDescription" single-line
                        required></v-text-field>
        </v-flex>
        <v-flex lg12 v-if="departmentList.length != 0">
          <label class="blackLabel">* Status Description:</label>
          <v-text-field label="Status Description" :rules="nameRules" solo v-model="statusDescription" single-line
                        required></v-text-field>
        </v-flex>
        <v-flex lg12>
          <label class="blackLabel">Status Reasons: <small>( Too expensive, Timing, Not needed anymore etc
            )</small></label>
          <v-text-field label="Status Reasons" solo v-model="statusReasons" single-line required></v-text-field>
        </v-flex>
        <v-flex lg6 v-if="departmentList.length > 0 && fncCheckDeps()">
          <label class="blackLabel">* Status Department:</label>
          <small>These departments will have access to this status</small>
          <v-select :items="departmentList" v-model="statusDepartment" item-value="id" item-text="name"
                    label="Status Department" autocomplete multiple solo></v-select>
          <!--<v-select :items="departmentList" v-model="statusDepartment" item-value="id" item-text="name" label="Unassigned Department" autocomplete solo></v-select>-->
        </v-flex>
        <v-flex lg6 v-if="userRoles.length > 0 && departmentList.length != 0 && fncCheckDeps()">
          <label class="blackLabel">* Status Roles:</label>
          <small>These roles will be able to change a quote to this status</small>
          <v-select :items="userRoles" v-model="statusRoles" item-value="id" item-text="name" label="Status Role"
                    autocomplete multiple solo></v-select>
        </v-flex>
        <v-flex lg12>
          <label class="blackLabel"><strong>PIPELINE STATUS GROUPING *</strong></label>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_new_lead'" label="New Leads" v-model="new_lead"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_initial_engagement_quote'" label="Initial Engagement & Quoting" v-model="initial_engagement_quoting"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_negotiating_customer_approval'" label="Negotiating Customer Approval" v-model="negotiating_customer_approval"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_manufacturer_fulfilment'" label="Manufacturer & Fulfilment" v-model="manufacturer_fulfilment"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_cancelled_expired_rejected'" label="Cancelled, Expired or Rejected" v-model="cancelled_expired_rejected"></v-switch>
        </v-flex>
        <v-flex lg12>
          <label class="blackLabel"><strong>GENERAL STATUS FLAGS</strong></label>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Converted" v-model="is_converted"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="New Lead" v-model="is_new_lead"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Gathering Customer Requirements" v-model="is_gathering_customer_reqs"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Quote Sent - Following Up" v-model="is_quote_sent"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Requote Requested" v-model="is_requote_requested"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Rejected" v-model="is_rejected"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Awaiting Acceptance" v-model="awaitingAcceptance"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Requirements Sent to Design Team" v-model="is_reqs_sent_to_design_team"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Quote Completed by Design team" v-model="is_quote_completed_by_design_team"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Accepted Status" v-model="acceptedStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Cancel Status" v-model="cancelStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Expired Status" v-model="expiredStatus"></v-switch>
        </v-flex>

        <v-flex lg12>
          <label class="blackLabel"><strong>STATUS API TRIGGERS</strong></label>
        </v-flex>
        <!--<v-flex lg3>
          <v-switch label="Creates an Order" v-model="createOrder"></v-switch>
        </v-flex>-->
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Locks Quote" v-model="locksQuote"></v-switch>
        </v-flex>

        <!--<v-flex lg3>
          <v-switch label="Tender Winning Status" v-model="tenderWinningStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Create Invoice" v-model="createInvoice"></v-switch>
        </v-flex>

        <v-flex lg3>
          <v-switch label="Triggers Notifications" v-model="triggersNotifications"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Initial Tender Status" v-model="initialTenderStatus"></v-switch>
        </v-flex>

        <v-flex lg3>
          <v-switch label="Flag on Quote Report" v-model="flagQuoteReport"></v-switch>
        </v-flex>-->
        <v-flex lg3>
          <v-switch v-if="globalModalParams.hasCheckedOut == false" label="Checked Out Online"
                    v-model="checkedStatus"></v-switch>
          <v-switch v-if="globalModalParams.hasCheckedOut == true" :disabled="true" label="Checked Out Online"
                    v-model="checkedStatus"></v-switch>
          <!--<small  v-if="globalModalParams.hasCheckedOut == true" style="float: left;display: block; margin-top: -22px;font-size: 10px;"><strong>{{ globalModalParams.hasCheckedOutText }}</strong> marked as "Checked Out"</small>-->
          <small style="float: left;display: block; margin-top: -22px;font-size: 10px;">Reduces Stock</small>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Show Order Button" v-model="vendorStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Accept" v-model="customerAccept"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Accept Final" v-model="customerAcceptFinal"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Reject" v-model="customerReject"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Request for Requote" v-model="reorderQuote"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Dispatched Status" v-model="dispatchedStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Picked Status" v-model="pickedStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Print Status" v-model="printStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send to Hybris Trolley" v-model="hybrisTrolleyStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send to Hybris Shopping List" v-model="hybrisStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Status that you cant move back from once payment has been made"
                    v-model="backStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Status that you cant move passed before payment has been made"
                    v-model="forwardStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Manufactured Status" v-model="manufacturedStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Delivered to Store Status" v-model="deliveredToStoreStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Process Order" v-model="is_process_order"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Is Waiting For Tender" v-model="is_waiting_tender"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Is POD Uploaded" v-model="is_pod_uploaded"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send To Customer" v-model="is_customer_send"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Ignore For Reporting" v-model="is_ignore"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="PO Received" v-model="poStatus"></v-switch>
        </v-flex>
        <v-flex lg3>
          <label class="blackLabel">* Status Color:</label>
          <swatches v-model="styleColor" colors="text-advanced" popover-to="right" />
        </v-flex>
        <v-flex lg12 v-if="objAuthorize.hide_ecommerce == 1">
          <label class="blackLabel"><strong>E-COMMERCE FLAG STATUS</strong></label>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Cancelled" v-model="is_ecommerce_cancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Pending" v-model="is_ecommerce_pending"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Successful" v-model="is_ecommerce_success"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Failed" v-model="is_ecommerce_failed"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Is Delivered" v-model="is_delivered"></v-switch>
        </v-flex>
        <v-flex lg12 v-if="objAuthorize.manufacturer == '385889803'">
          <label class="blackLabel"><strong>4SURE STATUSES</strong></label>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installation In Progress Status" v-model="installationWipStatus"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installation Complete Status" v-model="installationCompleteStatus"></v-switch>
        </v-flex>

        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Job Completed" v-model="fsJobCompleted"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Job Cancelled" v-model="fsJobCancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Awaiting Stock" v-model="fsAwaitingStock"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="TL On Site" v-model="fsTlOnSite"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Work Paused" v-model="fsWordPaused"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="No Appointment" v-model="fsNoAppointment"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Ready For Delivery" v-model="fsReadyForDelivery"></v-switch>
        </v-flex>

        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer Allocated" v-model="fsInstallerAllocated"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer On Route - Stock Collect" v-model="fsInstallerOnRouteStockCollect"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer At Dispatch" v-model="fsInstallerAtDispatch"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Collection Cancelled" v-model="fsCollectionCancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer On Route - Customer" v-model="fsInstallerOnRouteCustomer"></v-switch>
        </v-flex>

        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
<!--            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey"-->
<!--                                 class="pt-3 loginLoader"></v-progress-circular>-->
<!--            <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid"-->
<!--                   @click.stop="fncAddStatus()">Save-->
<!--            </v-btn>-->
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="update_vars" @click.stop="fncAddStatus()">Save</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Swatches from 'vue-swatches';
  import "vue-swatches/dist/vue-swatches.min.css";

  export default {
    name: 'Settings',
    components: { Swatches },
    data () {
      return {
        found:false,
        currentSelected: null,
        runAdd: false,
        isAddValid: false,
        statusDescription: '',
        createOrder: false,
        locksQuote: false,
        acceptedStatus: false,
        tenderWinningStatus: false,
        createInvoice: false,
        cancelStatus: false,
        statusReasons: '',
        triggersNotifications: false,
        initialTenderStatus: false,
        expiredStatus: false,
        poStatus: false,
        convertedStatus: false,
        checkedStatus: false,
        vendorStatus: false,
        flagQuoteReport: false,
        awaitingAcceptance: false,
        customerAcceptFinal: false,
        customerAccept: false,
        customerReject: false,
        reorderQuote: false,
        dispatchedStatus: false,
        pickedStatus: false,
        installationWipStatus: false,
        fsJobCompleted: false,
        fsJobCancelled: false,
        fsAwaitingStock: false,
        fsTlOnSite: false,
        fsWordPaused: false,
        fsNoAppointment: false,
        fsReadyForDelivery: false,
        installationCompleteStatus: false,
        printStatus: false,
        hybrisStatus: false,
        hybrisTrolleyStatus: false,
        backStatus: false,
        forwardStatus: false,
        manufacturedStatus: false,
        deliveredToStoreStatus: false,
        styleColor: '#cccccc',
        statusOrder: '',
        statusDepartment: [],
        statusRoles: [],
        nameRules: [
          v => !!v || 'Status name is required',
        ],
        colorRules: [
          v => !!v || 'Status color is required',
        ],
        orderRules: [
          v => !!v || 'Status order is required',
        ],
        is_ecommerce_cancelled: false,
        is_ecommerce_pending: false,
        is_ecommerce_success: false,
        is_ecommerce_failed: false,
        is_waiting_tender: false,
        is_pod_uploaded: false,
        is_customer_send: false,
        is_ignore: false,
        is_process_order: false,
        fsInstallerAllocated: false,
        fsInstallerOnRouteStockCollect: false,
        fsInstallerAtDispatch: false,
        fsCollectionCancelled: false,
        fsInstallerOnRouteCustomer: false,
        is_delivered: false,
        is_new_lead: false,
        is_gathering_customer_reqs: false,
        is_quote_sent: false,
        is_requote_requested: false,
        is_rejected: false,
        is_converted: false,
        is_reqs_sent_to_design_team: false,
        is_quote_completed_by_design_team: false,
        new_lead: false,
        initial_engagement_quoting: false,
        negotiating_customer_approval: false,
        manufacturer_fulfilment: false,
        cancelled_expired_rejected: false
      };
    },
    methods: {
      fncCheckDeps() {
        return this.$store.getters.branchActive;
      },
      fncHideModal () {
        window.location.reload();
      },
      fncAddStatus() {
        this.runAdd = true;
        this.$store.dispatch({
          type: 'fncAddStatus',
          settings: {
            statusDescription: this.statusDescription,
            createOrder: this.createOrder,
            locksQuote: this.locksQuote,
            acceptedStatus: this.acceptedStatus,
            tenderWinningStatus: this.tenderWinningStatus,
            createInvoice: this.createInvoice,
            cancelStatus: this.cancelStatus,
            poStatus: this.poStatus,
            triggersNotifications: this.triggersNotifications,
            initialTenderStatus: this.initialTenderStatus,
            expiredStatus: this.expiredStatus,
            flagQuoteReport: this.flagQuoteReport,
            checkedStatus: this.checkedStatus,
            convertedStatus: this.convertedStatus,
            vendorStatus: this.vendorStatus,
            awaitingAcceptance: this.awaitingAcceptance,
            customerAcceptFinal: this.customerAcceptFinal,
            customerAccept: this.customerAccept,
            customerReject: this.customerReject,
            reorderQuote: this.reorderQuote,
            styleColor: this.styleColor,
            statusDepartment: this.statusDepartment.join(),
            statusRoles: this.statusRoles,
            dispatchedStatus: this.dispatchedStatus,
            pickedStatus: this.pickedStatus,
            installationWipStatus: this.installationWipStatus,
            installationCompleteStatus: this.installationCompleteStatus,
            printStatus: this.printStatus,
            hybrisStatus: this.hybrisStatus,
            hybrisTrolleyStatus: this.hybrisTrolleyStatus,
            backStatus: this.backStatus,
            forwardStatus: this.forwardStatus,
            manufacturedStatus: this.manufacturedStatus,
            deliveredToStoreStatus: this.deliveredToStoreStatus,
            isEcommerceCancelled: this.is_ecommerce_cancelled,
            isEcommercePending: this.is_ecommerce_pending,
            isEcommerceSuccess: this.is_ecommerce_success,
            isEcommerceFailed: this.is_ecommerce_failed,
            fsJobCompleted: this.fsJobCompleted,
            fsJobCancelled: this.fsJobCancelled,
            fsAwaitingStock: this.fsAwaitingStock,
            fsTlOnSite: this.fsTlOnSite,
            fsWordPaused: this.fsWordPaused,
            fsNoAppointment: this.fsNoAppointment,
            fsReadyForDelivery: this.fsReadyForDelivery,
            fsInstallerAllocated: this.fsInstallerAllocated,
            fsInstallerOnRouteStockCollect: this.fsInstallerOnRouteStockCollect,
            fsInstallerAtDispatch: this.fsInstallerAtDispatch,
            fsCollectionCancelled: this.fsCollectionCancelled,
            fsInstallerOnRouteCustomer: this.fsInstallerOnRouteCustomer,
            isProcessOrder: this.is_process_order,
            reasons: this.statusReasons,
            isDelivered: this.is_delivered,
            isWaitingTender: this.is_waiting_tender,
            isPodUploaded: this.is_pod_uploaded,
            isCustomerSend: this.is_customer_send,
            isNewLead: this.is_new_lead,
            isGatheringCustomerReqs: this.is_gathering_customer_reqs,
            isQuoteSent: this.is_quote_sent,
            isRequoteRequested: this.is_requote_requested,
            isRejected: this.is_rejected,
            isReqsSentToDesignTeam: this.is_reqs_sent_to_design_team,
            isQuoteCompletedByDesignTeam: this.is_quote_completed_by_design_team,
            isIgnore: this.is_ignore,
            initial_engagement_quoting: this.initial_engagement_quoting,
            negotiating_customer_approval: this.negotiating_customer_approval,
            manufacturer_fulfilment: this.manufacturer_fulfilment,
            cancelled_expired_rejected: this.cancelled_expired_rejected,
            //statusOrder: this.statusOrder
          }
        });
        this.runAdd = false;
      },

    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'statusList',
        'globalModalParams',
        'departmentList',
        'userRoles',
        'departmentStatusFilter'
      ])
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateRoles');
    },
    mounted() {
      this.statusDepartment.push( parseInt( this.departmentStatusFilter ) );

      /*for( var u in this.userRoles ) {
        this.statusRoles.push( this.userRoles[u].id );
      }*/

      // this.statusDepartment = this.departmentStatusFilter;
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'statusList',
        'globalModalParams',
        'departmentList',
        'userRoles',
        'departmentStatusFilter'
      ]),
      update_vars(){
        if (this.isAddValid && this.found)
          return  false
        else
          return  true
      },
      validateStatuses()
      {
        if(this.new_lead){
          this.currentSelected = 'new_lead'
          return true
        }
        if (this.initial_engagement_quoting){
          this.currentSelected = 'is_initial_engagement_quote'
          return true
        }
        if (this.negotiating_customer_approval){
          this.currentSelected = 'is_negotiating_customer_approval'
          return true
        }
        if (this.manufacturer_fulfilment){
          this.currentSelected = 'is_manufacturer_fulfilment'
          return true
        }
        if (this.cancelled_expired_rejected){
          this.currentSelected = 'is_cancelled_expired_rejected'
          return true
        }
        else{
          this.currentSelected = null
          return false
        }
      }
    },
    watch: {
      /*userRoles() {
        this.statusRoles = [];
        for( var u in this.userRoles ) {
          this.statusRoles.push( this.userRoles[u].id );
        }
      }*/
      new_lead(){
        this.found = this.validateStatuses
      },
      initial_engagement_quoting(){
        this.found = this.validateStatuses
      },
      negotiating_customer_approval(){
        this.found = this.validateStatuses
      },
      manufacturer_fulfilment(){
        this.found = this.validateStatuses
      },
      cancelled_expired_rejected(){
        this.found = this.validateStatuses
      }
    }
  }

</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
